import { toQueryString } from "../../toQueryString";
import { absolutePath } from "../absolutePath";

export interface CommunityReviewsIndexParams {
  end_date?: string;
  filters?: unknown;
  page?: number;
  per_page?: number;
  query?: string;
  ratings?: number[];
  sort?: "highest" | "lowest" | "newest";
  start_date?: string;
  tag_keys?: string[];
}

export const communityReviews = {
  // `filters` (the nested member-filter rows) needs indexed array notation to
  // reach the controller as an array of hashes; `ratings`/`tag_keys` are flat
  // arrays and need the default bracket notation instead, or Rails parses
  // them as hashes. The two can't share one `arrayFormat`, so they're
  // serialized separately and joined.
  index: ({ filters, ...rest }: CommunityReviewsIndexParams) => {
    const path = absolutePath("admin/community_reviews", rest);
    if (!filters) return path;

    return `${path}&${toQueryString({ filters }, { arrayFormat: "indices" })}`;
  },
  membersSay: () => absolutePath("admin/community_reviews/members_say"),
};
